import { render, staticRenderFns } from "./GestionarSolicitudes.vue?vue&type=template&id=7c7be972&scoped=true"
import script from "./GestionarSolicitudes.vue?vue&type=script&setup=true&lang=js"
export * from "./GestionarSolicitudes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./GestionarSolicitudes.vue?vue&type=style&index=0&id=7c7be972&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7be972",
  null
  
)

export default component.exports